class megaMenuSupport{
	constructor() {
		this.currentlyOpenedIndex = -1;
	}
	dropdowns(el) {
		window.app.nav.normalizeDropdownHeight(el);
		let selector = el.getAttribute('data-selector');
		// console.log(selector);
		let toggles = Array.from(el.querySelectorAll(selector));
		toggles.forEach(toggle => {
			let hoverableItem = toggle.querySelector('a:not(.js-ignore)');
			if (hoverableItem) {
				hoverableItem.addEventListener('mouseenter', () => {
					if (toggles.some(toggle => toggle.classList.contains('show'))) {
						if (!toggle.classList.contains('show')) $(toggle.querySelector('a')).dropdown('toggle');
					}
				});
			}
			$(toggle).on('show.bs.dropdown', e => {
				el.classList.add('mega-active');
			});
			$(toggle).on('hidden.bs.dropdown', (e) => {
				el.classList.remove('mega-active');
			});
		});

	}
	stopClickProp(el) {
		el.addEventListener('click', e => {
			e.preventDefault();
			e.stopPropagation();
			if (el.contains(e.target) && parseInt(e.target.getAttribute('data-slide-to'))) {
				$(el).carousel(parseInt(e.target.getAttribute('data-slide-to')));
			}
		});
	}
	carousel(el){
		let tiles = Array.from(el.querySelectorAll('[data-slide-to]'));
		tiles.forEach(tile => {
			window.app.util.multiEventBind(tile, 'mouseover focus', () => {
				$(el).carousel(parseInt(tile.getAttribute('data-slide-to')));
			});
		});
	}
}
window.app.add('mega-menu', new megaMenuSupport());